import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "input"]

  connect() {
    // Initialize input with editor content
    this.syncToInput()

    // Listen for input changes
    this.editorTarget.addEventListener("input", () => this.syncToInput())
    this.editorTarget.addEventListener("blur", () => this.syncToInput())

    // Handle paste - strip formatting except basic HTML
    this.editorTarget.addEventListener("paste", (e) => this.handlePaste(e))
  }

  syncToInput() {
    // Get HTML content and clean it
    let content = this.editorTarget.innerHTML

    // Remove empty content
    if (content === "<br>" || content === "<div><br></div>") {
      content = ""
    }

    this.inputTarget.value = content
  }

  handlePaste(e) {
    e.preventDefault()
    const text = e.clipboardData.getData("text/plain")
    document.execCommand("insertText", false, text)
  }

  bold(e) {
    e.preventDefault()
    document.execCommand("bold", false, null)
    this.editorTarget.focus()
  }

  italic(e) {
    e.preventDefault()
    document.execCommand("italic", false, null)
    this.editorTarget.focus()
  }

  bulletList(e) {
    e.preventDefault()
    document.execCommand("insertUnorderedList", false, null)
    this.editorTarget.focus()
  }

  numberedList(e) {
    e.preventDefault()
    document.execCommand("insertOrderedList", false, null)
    this.editorTarget.focus()
  }

  link(e) {
    e.preventDefault()
    const selection = window.getSelection()
    const selectedText = selection.toString()

    const url = prompt("Enter URL:", "https://")
    if (url && url !== "https://") {
      // Create link with target="_blank"
      if (selectedText) {
        document.execCommand("insertHTML", false, `<a href="${this.escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${this.escapeHtml(selectedText)}</a>`)
      } else {
        document.execCommand("insertHTML", false, `<a href="${this.escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${this.escapeHtml(url)}</a>`)
      }
    }
    this.editorTarget.focus()
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
